import React from 'react';
import { fetchApi } from '@api/fetchApi';
import { keyMap } from '@locales/lokalise/keyMap';
import { handleError } from '@utils/errors';
import { UploadMultiFileInput } from '.';
import type { IFileItem } from '../../../../global.interfaces';
import { IUploadFileInputProps } from './types';

/**
 * @deprecated
 * Please use UploadFile for new forms.
 *
 * import { UploadFile } from '@components-library/UploadFile';
 */

export const UploadFileInput = (props: IUploadFileInputProps): JSX.Element => {
  const onChange = (name: string, files: File[] | null) => {
    if (files === null) {
      return props.onChange(name, null);
    }

    props.onChange(name, files[0]);
  };

  const getFileModel = async (files: File[]) => {
    if (props.uploadApi) {
      const formData = new FormData();

      formData.append('file', files[0]);

      try {
        const response = await fetchApi.post<{ model: IFileItem }>(props.uploadApi, formData, {
          headers: { 'content-type': 'multipart/form-data' },
        });

        if (props.onDropHandler) {
          props.onDropHandler(files[0], response);
        }
      } catch (error) {
        handleError(keyMap.settingsDocsFormUploadErrorMessage, error);
      }
    }
  };

  const value = props.value ? [props.value] : null;

  return (
    <UploadMultiFileInput
      {...props}
      onDropHandler={getFileModel}
      value={value}
      title={props.title}
      name={props.name}
      valid={props.valid}
      validationMessage={props.validationMessage}
      attributes={props.attributes}
      accept={props.accept}
      required={props.required}
      className={props.className}
      onChange={onChange}
    />
  );
};
